<template>
  <div>
    <v-title>
      {{ phoneNumber && phoneNumber.did ? 'Update' : 'Choose' }} Phone number
    </v-title>
    <v-card>
      <v-card-text>
        <v-card>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs4>
                <vonex-select
                  name="rangeSize"
                  label="Range Size"
                  v-model="phoneNumber.range"
                  :items="[1, 10, 100]"
                  @change="onUpdateRange"
                />
              </v-flex>
              <v-flex xs4>
                <vonex-select
                  v-model="phoneNumber.state"
                  name="State"
                  label="Select your state"
                  hide-details
                  item-value="value"
                  item-text="label"
                  :items="filteredStates"
                  @change="onUpdateState"
                ></vonex-select>
              </v-flex>
              <v-flex xs4>
                <vonex-select
                  label="Select your Region"
                  v-model="phoneNumber.region"
                  name="region"
                  item-value="description"
                  :items="filteredRegions"
                  @change="onUpdateRegion"
                >
                  <template v-slot:item="{ item }">
                    <div>
                      {{ `${item.description}(${item.count})` }}
                    </div>
                  </template>

                  <!-- Customize how the selected item is displayed -->
                  <template v-slot:selection="{ item }">
                    <div>
                      {{ `${item.description}(${item.count})` }}
                    </div>
                  </template>
                </vonex-select>
              </v-flex>
              <v-flex xs3>
                <vonex-select
                  name="AvailableNumber"
                  label="-- Select a Number"
                  v-model="phoneNumber.did"
                  :items="filteredAvailableNumbers"
                  item-text="display"
                  item-value="phone_number"
                >
                  <template v-slot:item="{ item }">
                    <div>
                      {{ item.display }}
                    </div>
                  </template>

                  <!-- Customize how the selected item is displayed -->
                  <template v-slot:selection="{ item }">
                    <div>
                      {{ item.display }}
                    </div>
                  </template>
                </vonex-select>
              </v-flex>
              <v-flex xs2>
                <vonex-select
                  label="RatePlan"
                  name="Rateplan"
                  item-text="ratePlanDescription"
                  item-value="ratePlanID"
                  v-model="phoneNumber.ratePlanId"
                  :items="
                    ratePlans.filter((x) => {
                      var regex = new RegExp(''.split(' ').join('.*'), 'i');
                      return (
                        x.usageType.toLowerCase() == 'did' &&
                        regex.test(
                          x.ratePlanDescription.toLowerCase() ||
                            regex.test(x.ratePlanID.toString())
                        )
                      );
                    })
                  "
                />
              </v-flex>
              <v-flex xs3>
                <v-radio-group
                  v-model="phoneNumber.directoryListing"
                  class="ml-5"
                  row
                >
                  <template v-slot:label>
                    <div>Directory Listing</div>
                  </template>
                  <v-radio label="Yes" value="LE"></v-radio>
                  <v-radio label="No" value="UL"></v-radio>
                </v-radio-group>
              </v-flex>
              <v-flex xs4>
                <IpExtensionHardware
                  @setAddress="setAssignedAddress"
                  :addressId="phoneNumber.addressId"
                />
              </v-flex>
            </v-layout>
            <v-card-actions>
              <v-btn
                color="primary"
                :disabled="invalid"
                @click="reservePhoneNumber"
              >
                Save
              </v-btn>
              <v-btn @click="closeDialog">Cancel</v-btn>
            </v-card-actions>
          </v-container>
        </v-card>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import IpExtensionHardware from './ip-extensions-hardware.vue';
import { mapIPVoiceMultiRowFields } from '../store/modules/orders';
import { createNamespacedHelpers } from 'vuex';
const { mapActions: mapIPVoiceActions } =
  createNamespacedHelpers(`orders/ipVoice`);
export default {
  components: {
    IpExtensionHardware,
  },
  props: ['_phoneNumber', 'selectedIndex'],
  data() {
    return {
      phoneNumber: {
        domain_name: '',
        customer_number: 0,
        did: '',
        ratePlanId: 0,
        addressId: 0,
        directoryListing: 'UL',
        ipnd_action: 'ADD',
        id: 0,
        is_temp_preport: true,
        range: 0,
        state: '',
        region: '',
        from_update: false,
        orderId: 0,
      },
      regions: [],
    };
  },
  computed: {
    ...mapIPVoiceMultiRowFields([
      'ratePlans',
      'phoneRegions',
      'reservedNumbers',
      'availableNumbers',
    ]),
    filteredStates() {
      let vm = this;
      return vm.phoneRegions
        .filter((p) => p.count)
        .reduce((acc, p) => {
          const state = p.state;
          if (!acc.some((item) => item.value === state)) {
            acc.push({
              label: state,
              value: state,
            });
          }
          return acc;
        }, []);
    },
    filteredRegions() {
      let vm = this;
      return vm.phoneNumber.state
        ? vm.phoneRegions.filter(
            (p) =>
              p.count &&
              p.state.toLowerCase() == vm.phoneNumber.state.toLowerCase()
          )
        : [];
    },
    invalid() {
      const { did, ratePlanId, addressId, range, state, region } =
        this.phoneNumber;
      return (
        did == '' ||
        ratePlanId <= 0 ||
        addressId <= 0 ||
        range <= 0 ||
        state == '' ||
        region == ''
      );
    },
    filteredAvailableNumbers() {
      let vm = this;
      return vm.availableNumbers.filter((x) => {
        return (
          vm.reservedNumbers.map((e) => e.did).indexOf(x.phone_number) == -1
        );
      });
    },
  },
  watch: {
    _phoneNumber: {
      handler(newValue) {
        this.phoneNumber = { ...newValue };
      },
      deep: true,
    },
  },
  methods: {
    ...mapIPVoiceActions([
      'getPhoneRegionsAsync',
      'getAvailablePhoneNumbersAsync',
    ]),
    async onUpdateRange() {
      let vm = this;
      var result = await vm.getPhoneRegionsAsync({
        range: vm.phoneNumber.range,
      });
      vm.regions = result;
    },
    async onUpdateRegion() {
      let vm = this;
      var current_region = vm.filteredRegions.find(
        (x) => x.description == vm.phoneNumber.region
      );
      var request = {
        quantity: vm.phoneNumber.range,
        region: vm.phoneNumber.region,
        pageSize: current_region.count,
      };
      await vm.getAvailablePhoneNumbersAsync({ request });
    },
    onUpdateState() {
      this.phoneNumber.region = '';
      this.phoneNumber.did = '';
    },
    async reservePhoneNumber() {
      this.$emit('reservePhoneNumber', this.phoneNumber);
      this.phoneNumber = {
        domain_name: '',
        customer_number: 0,
        did: '',
        ratePlanId: 0,
        addressId: 0,
        directoryListing: 'UL',
        ipnd_action: 'ADD',
        id: 0,
        is_temp_preport: true,
        range: 0,
        state: '',
        region: '',
        orderId: 0,
        from_update: false,
      };
    },
    setAssignedAddress(data) {
      let vm = this;
      vm.phoneNumber.addressId = data;
    },
    closeDialog() {
      this.$emit('closeDialog');
    },
  },
  async mounted() {
    if (!this.regions.length) {
      this.regions = this.phoneRegions;
    }

    await this.onUpdateRange();
  },
};
</script>
